import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import LoadDetailsContainer from '../../../components/componentsTrans/LoadDetails/LoadDetailsContainer';
import { Message } from 'rsuite';

class transLoadDetailsView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

    render() {

        if (typeof (this.props.warehouseSelection) !== 'number' || typeof (this.props.customerSelection) !== 'number') {
            return <AnimatedView><Message style={{ marginTop: '25px' }} type="info" description="Please select only one Warehouse and one Customer to view all data." /></AnimatedView>;
        }

        return (
            <AnimatedView>
                <LoadDetailsContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default transLoadDetailsView;
